import { useState, useEffect, useRef } from "react";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ReactCountryFlag from "react-country-flag";
import Container from 'react-bootstrap/Container';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../img/timologic.png';
import LogoEmpty from '../../img/logo-empty.png';
import ApiClient from "../../services/api-client";
import { useTranslation } from 'react-i18next';
import Wizard from "../wizard/wizard.component";
import ChooseCompanyModal from "../modals/choose-company";
import pflogo from '../../img/profile.png';
import { logout } from '../../util/AuthUtils';
import Commons from '../../util/commons';
import { toast } from 'react-toastify';
import ParochosFormModal from "../modals/parochos-form-modal";
import useStore from "../../hooks/useStore";


export default function MainNavBar(props) {

    const loggedInUser = useStore(state => state.loggedInUser);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [showWizard, setShowWizard] = useState(false);
    const wizardRef = useRef();
    const [newNotifications, setNewNotifications] = useState();
    const parochosFormModalRef = useRef();
    const chooseCompanyModalRef = useRef();
    const [selectedCompany, setSelectedCompany] = useState({ name: "" });
    const [expanded, setExpanded] = useState(false);

    const urlShowWizard = new URLSearchParams(window.location.search).get('wizard');

    const handleCloseWizard = () => setShowWizard(false);

    const handleCloseCompanyModal = () => {
        setSelectedCompany(useStore.getState().selectedCompany);
        chooseCompanyModalRef.current.close();
        setTimeout(() => window.location.reload(), 1000);
    };

    const handleShowCompanyModal = () => chooseCompanyModalRef.current.open();

    const updateUserIsOnNotifyState = () => {
        ApiClient.updateUserIsOnNotifyState().then(
            response => {
                if (response) {
                    const user = { ...useStore.getState().loggedInUser };
                    user.isOnNotifyState = false;
                    localStorage.setItem("user", JSON.stringify(user));
                    setNewNotifications(<></>);
                }
            },
            error => console.error(error.data)
        );
    };

    useEffect(() => {
        const usr = useStore.getState().loggedInUser;
        const showWiz = !!(usr?.wizard || urlShowWizard);

        if (showWiz) {
            setShowWizard(true);
        } else {
            const company = useStore.getState().selectedCompany;
            if (company) setSelectedCompany(company);
            else chooseCompanyModalRef.current.open();
        }

        if (usr?.isOnNotifyState) {
            setNewNotifications(
                <Nav.Item>
                    <Nav.Link>
                        <span className="fa-stack fa-1x blob red" onClick={updateUserIsOnNotifyState} title={t("userHasNewMessages")}>
                            <i className="fa fa-envelope fa-stack-1x"></i>
                            <i className="fa fa-exclamation fa-stack-1x" style={{ color: "red" }}></i>
                        </span>
                    </Nav.Link>
                </Nav.Item>
            );
        }

        if (i18n.language === "en-US") {
            i18n.changeLanguage("gr");
        }
    }, []);

    const getCompaniesUrl = () => `/usercompany/${selectedCompany?.id || ""}`;

    const iOS = () =>
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform)
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document);

    const isEmpty = obj => Object.keys(obj).length === 0;

    const handleSaveAndExit = () => {
        const data = wizardRef.current.getValues();
        const errors = wizardRef.current.getErrors();
        setTimeout(() => {
            if (isEmpty(Object.values(errors)[0])) {
                SaveChanges(data);
            }
        }, 100);
    };

    function SaveChanges(data) {
        localStorage.removeItem("wizard");
        const company = {
            name: data.name,
            taxpayerId: data.taxpayerId ? data.taxpayerId.trim() : "",
            taxOffice: data.taxOffice?.id ? { id: data.taxOffice.value } : null,
            branches: [{
                name: data.name,
                subjectField: data.subjectField,
                address: data.address,
                branchNumber: 0
            }]
        };
        
        ApiClient.saveCompany(company).then(
            response => {
                const savedCompany = response.data;
                const invoiceTypes = data.myDataInvoiceType.map(el => ({
                    company: { id: savedCompany.id },
                    name: el.label,
                    myDataInvoiceType: el.value,
                    series: [{ name: "A", branch: { id: savedCompany.branches[0].id }, startNumber: 0 }]
                }));

                ApiClient.saveBulkInvoiceTypeWithSeries(savedCompany.id,invoiceTypes).then(
                    () => ApiClient.UpdateUserWizard().then(response => {
                        toast.success(t("saveSucceded"));
                        localStorage.setItem("company", JSON.stringify(savedCompany));
                        localStorage.setItem("user", JSON.stringify(response.data));
                        Commons.setDefault("invoiceTypeMessages", ["invoice2_1", "invoice11_1", "invoice1_01"]);
                        navigate("/sale");
                        window.location.reload();
                    }),
                    error => {
                        toast.error("Error: " + error.data);
                        console.error(error.data);
                    }
                );
                setShowWizard(false);
            },
            error => {
                toast.error(error.message + ": " + error.response.data.message, 20000);
                console.error(error.response.data.message);
            }
        );
    }

    const avatarSrc = loggedInUser?.imageUrl || pflogo;
    const showPayMenu = loggedInUser?.lastTransactionDate == null && !iOS();

    const managerMenu = (
        <NavDropdown active={["/invoicetypes", "/usercompanies"].includes(window.location.pathname)} title={t("Settings")}>
            <NavDropdown.Item active={window.location.pathname === "/usercompanies" || window.location.pathname.includes("/usercompany")} onClick={() => setExpanded(false)} as={Link} to={getCompaniesUrl()}>{t("userCompanies")}</NavDropdown.Item>
            <NavDropdown.Item active={window.location.pathname === "/invoicetypes"} onClick={() => setExpanded(false)} as={Link} to="/invoicetypes">{t("invtypes")}</NavDropdown.Item>
            <NavDropdown.Item active={window.location.pathname === "/productCategories"} onClick={() => setExpanded(false)} as={Link} to="/productCategories">{t("classificationsOfProducts")}</NavDropdown.Item>
            <NavDropdown.Item active={window.location.pathname === "/templates"} onClick={() => setExpanded(false)} as={Link} to="/templates">{t("invoiceDesigner")}</NavDropdown.Item>
            <NavDropdown.Item active={window.location.pathname === "/deductions"} onClick={() => setExpanded(false)} as={Link} to="/deductions">{t("Deductions")}</NavDropdown.Item>
            <NavDropdown.Item active={window.location.pathname === "/aade/sale"} onClick={() => setExpanded(false)} as={Link} to="/aade/sale">{t("searchByMarkFromAade")}</NavDropdown.Item>
            <NavDropdown.Item active={window.location.pathname === "/parochosform"} onClick={() => setExpanded(false)} as={Link} to="/parochosform">
                {t("parochosform")}<span style={{ marginLeft: 6, fontSize: 16 }} className="badge bg-success">{t("New")}</span>
            </NavDropdown.Item>
            <NavDropdown.Item active={window.location.pathname === "/requestpayments"} onClick={() => setExpanded(false)} as={Link} to="/requestpayments">{t("POStransactions")}</NavDropdown.Item>
            <NavDropdown.Item onClick={() => window.open("https://timologic.gr/blog/sindesi-eshop-mydata-timologisi/", '_blank')}>{t("eshopConnect")}</NavDropdown.Item>
        </NavDropdown>
    );

    const getLogo = () => {
        if (window.location !== window.parent.location) {
            window.parent.postMessage("messageFromNavbar", "*");
            return LogoEmpty;
        }
        return Logo;
    };

    return (
        <Navbar expanded={expanded} className="menunav" fixed="top" bg="dark" variant="dark" expand="lg">
            <Container fluid>
                <Navbar.Brand as={Link} to="/">
                    <img width="180px" height="auto" className="img-responsive" src={getLogo()} alt="logo" />
                </Navbar.Brand>
                <div className="d-flex main-nav-right-btns">
                    <Navbar.Toggle onClick={() => navigate(0)}><i className="fa fa-refresh"></i></Navbar.Toggle>
                    <Navbar.Toggle onClick={() => setExpanded(expanded ? false : "expanded")} id="main-nav-toogler" aria-controls="basic-navbar-nav" />
                </div>

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav activeKey={window.location.pathname} className="me-auto">
                        <Nav.Link className="desktop-only" active={window.location.pathname === "/"} as={Link} to="/"><i className="fa fa-2x fa-home"></i></Nav.Link>

                        <NavDropdown active={["/sales", "/sale"].includes(window.location.pathname)} title={t('DocumentTypes')}>
                            <NavDropdown.Item active={window.location.pathname === "/sale"} onClick={() => setExpanded(false)} as={Link} to="/sale">{t('PublishInvoiceNav')}</NavDropdown.Item>
                            <NavDropdown.Item active={window.location.pathname === "/sales"} onClick={() => setExpanded(false)} as={Link} to="/sales">{t('SalesSearchNav')}</NavDropdown.Item>
                            <NavDropdown.Item active={window.location.pathname === "/presales"} onClick={() => setExpanded(false)} as={Link} to="/presales">{t('PreSalesSearchNav')}</NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Item>
                            <Nav.Link active={window.location.pathname === "/customers"} onClick={() => setExpanded(false)} as={Link} to="/customers">{t("Customers")}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link active={window.location.pathname === "/products"} onClick={() => setExpanded(false)} as={Link} to="/products">{t("ProductsServices")}</Nav.Link>
                        </Nav.Item>

                        {managerMenu}
                        {showPayMenu && (
                            <Nav.Item>
                                <Nav.Link id="pay_btn" as={Link} to="/startSubscription">{t("subscription")}</Nav.Link>
                            </Nav.Item>
                        )}
                    </Nav>

                    <Nav className="right-navbar flex-row-reverse d-flex" style={{ paddingRight: 6 }}>
                        <Nav.Item>
                            <NavDropdown className="profile-dropdown" title={
                                <span className="profile-avatar-trigger">
                                    <img className="profile-avatar-img" alt="profile" src={avatarSrc} />
                                </span>
                            } id="profile-nav-dropdown" align="end">
                                <div className="profile-dropdown-header">
                                    <img className="profile-dropdown-avatar" alt="profile" src={avatarSrc} />
                                    <div className="profile-dropdown-info">
                                        <span className="profile-dropdown-name">{loggedInUser?.name || loggedInUser?.email}</span>
                                        <span className="profile-dropdown-email">{loggedInUser?.email}</span>
                                    </div>
                                </div>
                                <NavDropdown.Divider />
                                <NavDropdown.Item active={i18n.language === "gr"} onClick={() => i18n.changeLanguage("gr")} className="profile-dropdown-item">
                                    <ReactCountryFlag svg countryCode="GR" style={{ fontSize: '1.2em', marginRight: 6 }} /> GR — Ελληνικά
                                </NavDropdown.Item>
                                <NavDropdown.Item active={i18n.language === "gb"} onClick={() => i18n.changeLanguage("gb")} className="profile-dropdown-item">
                                    <ReactCountryFlag svg countryCode="GB" style={{ fontSize: '1.2em', marginRight: 6 }} /> GB — English
                                </NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item active={window.location.pathname === "/profile"} onClick={() => setExpanded(false)} as={Link} to="/profile" className="profile-dropdown-item">
                                    <i className="fa fa-user-circle-o"></i> {t("profile")}
                                </NavDropdown.Item>
                                <NavDropdown.Item id="logout_btn" onClick={() => logout()} className="profile-dropdown-item profile-dropdown-logout">
                                    <i className="fa fa-sign-out"></i> {t("Logout")}
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav.Item>

                        <Nav.Item>
                            {newNotifications}
                            <Button id="selectCompanyChoiceBtn" variant="primary" style={{ backgroundColor: 'transparent' }} onClick={handleShowCompanyModal}>
                                {selectedCompany?.name}
                            </Button>
                        </Nav.Item>
                    </Nav>
                </Navbar.Collapse>
            </Container>

            <Modal
                {...props}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showWizard}
                dialogClassName="wizard-modal"
                onHide={handleCloseWizard}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header className="wizard-modal-header">
                    <Modal.Title><i className="fa fa-magic" style={{ marginRight: 8 }}></i>{t("startWizardTitle")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="wizard-modal-body">
                    <Wizard ref={wizardRef} />
                </Modal.Body>
                <Modal.Footer className="wizard-modal-footer">
                    <Button className="btn-skin btn-lg" id="saveWizardBtn" variant="primary" onClick={handleSaveAndExit}>{t("iamready")}</Button>
                </Modal.Footer>
            </Modal>

            {!showWizard && <ChooseCompanyModal ref={chooseCompanyModalRef} handleCloseCompanyModal={handleCloseCompanyModal} />}
            <ParochosFormModal ref={parochosFormModalRef} />
        </Navbar>
    );
}
